import { render, staticRenderFns } from "./SalesLogList.vue?vue&type=template&id=bc77c44c&"
import script from "./SalesLogList.vue?vue&type=script&lang=js&"
export * from "./SalesLogList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports